// -*- Mode: rjsx -*-
import React from 'react';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import DateIcon from '@mui/icons-material/CalendarToday';

import Skeleton from 'react-loading-skeleton';
import FancyDate from '../../../ui/FancyDate';0



function Subheader(props) {
    let note = props.note;
    let user = note.user || {};
    return (
        <Grid container spacing={1} alignItems="center" >
          <Grid item>

          </Grid>
          <Grid item alignItems="center">

          </Grid>
        </Grid>        
    );
}



function CustomHeader(props) {
    let avatar = props.avatar;
    let title = props.title;
    let subtitle = props.subtitle;

    return (
        <CardHeader
          avatar={ avatar || <Skeleton width={48} height={48} /> }
          title={ title || <Skeleton width={150} /> }
          subheader={ subtitle || <Skeleton width={75} /> }
        />
    );
}


function Header(props) {
    let note = props.note;
    let user = note.user || {};
    return (
        <CustomHeader
          avatar={ user.key ? <Avatar alt={user.name} src={user.avatar_url} /> : null }
          title={ user.name ? user.name + " " + note.type + " " + note.content_type : null }
          subtitle={ note.date_created ? <FancyDate icon={true} date={note.date_created} /> : null }
        />
    );
}


export { CustomHeader };
export default Header;
